import OModal from './index.vue';

OModal.install = app => {
  app.component(OModal.name, OModal);
};

export default OModal;
